import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { FileOperationsController } from '@commoncore/controller/FileOperationsController';
import { GlobalService } from '@commoncore/services/global.service';
import { AppEvents } from '@commoncore/utils/app-events';
import { IndexedDBModule } from '@mainrepo/app/core/database/IndexedDBManager';


@Component({
  standalone:true,
  selector: 'lib-create-album',
  templateUrl: './create-album.component.html',
  styleUrls: ['./create-album.component.scss'],
  imports:[CommonModule]
})
export class CreateAlbumComponent implements OnInit {
  public universalService:any;
  public listService:any;
  @Input() enableButton:any;
  @Output() closecreateModal = new EventEmitter();
  @Output() createAlbumValidation = new EventEmitter();
  @Output() createAlbum = new EventEmitter();
  @Output() goback = new EventEmitter();
  public buttonText:any="";
  fileOpCtrl: any;
  db: IndexedDBModule;
  router:any;
  fileOpImplRef: any;
  //showCreateAlbumModal: boolean = false;

  
  
  constructor(
    public globalService:GlobalService,
    private changeDetector: ChangeDetectorRef) {
    this.setEnvObjects(globalService)
   }



  ngOnInit(): void {

    let classRef = this;
    AppEvents.globalObservable.subscribe(event => {
      if(event["createAlbum"]){
        classRef.universalService.showCreateAlbumModal = event["createAlbum"];
        (<HTMLInputElement>document.getElementById("AlbumName")).value = '';
        setTimeout(()=>{
          (<HTMLInputElement>document.getElementById("AlbumName")).focus();
        },100)
        this.setButtonText();
        classRef.changeDetector.detectChanges();
      } else if(event["closeAll"] || event["createAlbum"]== false){
        classRef.universalService.showCreateAlbumModal = false;
        classRef.changeDetector.detectChanges();
      }
    })
  }

  @HostListener('document:keydown', ['$event'])
  onKeyDownHandler(event: KeyboardEvent) {
    if (event.key === "Escape" && this.universalService.showCreateAlbumModal) {
     this.escKeyPressHandle(event)
    } 
  }


  setEnvObjects(globalService){
    this.universalService = globalService.getUniversalServiceRef();
    this.listService = globalService.getListServiceRef();
    this.fileOpCtrl = FileOperationsController.getInstance(this.globalService);
    this.fileOpImplRef = this.fileOpCtrl.fileOperationsImplementation;
    this.db = IndexedDBModule.getInstance(this.globalService);
    this.router = globalService.getRouterRef();
  }


  closeCreateModal(){
    this.closecreateModal.emit();
    AppEvents.globalObservable.next({createAlbum:false})
  }

  validateBeforeCreatingAlbum(message){
    const sanitizedMessage = message.value
    .replace(this.universalService.htmlAndDoctypeRegex, '')
    .replace(this.universalService.urlRegex, '') 
    .replace(this.universalService.lineBreakRegex, ' ');    
    message.value = sanitizedMessage;
    
    this.createAlbumValidation.emit(message);
  }
  
  createAlbumAndAdd(AlbumName){
    if(!this.listService.createAlbumObject){
      this.createNewAlbum(AlbumName.value)
    }else{
      this.universalService.showLoader = true;
      this.createAlbum.emit(AlbumName.value);
    }
  }

  goBackToPreviousScreen(){
    setTimeout(()=>{
      let el = document.getElementById('custome_backdrop')
      if(el){
        el.style.display = 'none';
      }
    },40);
    this.goback.emit();
    AppEvents.globalObservable.next({createAlbum:false})
  }


  async createNewAlbum(albumName){
    let albumObj = await this.fileOpCtrl.createAlbum(albumName);
    let quote = "\"";
    if(!this.router.url.includes('/albums/')){
      setTimeout(() => {
        let msg = "Album " + quote + albumObj.boardName + quote + " created successfully."
        this.universalService.showToast(msg, "success")
      }, 500);
    }else{
      AppEvents.albumDetails.next({'showFirstAlbumNoti':true,'boardName':albumObj.boardName})
    }
    ////Add to indexedDB on create
    var result = await this.db.add('MyAlbumsList', albumObj);
    AppEvents.globalObservable.next({createAlbum:false});
    this.universalService.scrollToTopIcon = false;
    this.universalService.currentAlbum = albumObj;
    AppEvents.albumDetails.observers = [];
    this.router.navigate(['/albums/myalbums', albumObj["boardKey"]]);
  }
 

  setButtonText(){
    this.buttonText = "Create";
  }

  escKeyPressHandle(e){
    setTimeout(()=>{
      // this.universalService.disableModalBackdrop();
      setTimeout(()=>{
        let el = document.getElementById('custome_backdrop')
        if(el){
          el.style.display = 'none';
        }
      },40);
      AppEvents.globalObservable.next({createAlbum:false})
      this.listService.createAlbumObject = false;
      e.stopPropagation();
    },100)
   
  }

  closeCreateAlbumModal(){
    this.fileOpImplRef.enableButton = false;
    this.universalService.popUpToBeOpened = '';
    this.listService.createAlbumObject = false;
    this.universalService.showCreateAlbumModal = false;
    AppEvents.globalObservable.next({createAlbum:false});
    // this.universalService.disableModalBackdrop();
    setTimeout(()=>{
      let el = document.getElementById('custome_backdrop')
      if(el){
        el.style.display = 'none';
      }
    },40);
  }
}
